import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect, withRouter } from 'react-router-dom';

import { homePath } from '../config/static/appConfig';

export const PublicRoute = ({ component: Component, ...rest }) => {
  let isloggedIn = useSelector(state => state.auth.isloggedIn);
  return (
    <Route
      {...rest}
      render={props =>
        !isloggedIn ? <Component {...props} /> : <Redirect to={homePath} />
      }
    />
  );
};
export default withRouter(PublicRoute);
